import { getSDKConfig } from '../../utils/config';

var ACM_GV_ANALYTICS = localStorage.getItem('ACM_GV_ANALYTICS');

export const isGVAllowed = () => {
  var shouldSendGodavari = false;

  const config = getSDKConfig();
  const { default_behavior = false } = config || {};

  if (default_behavior === true) {
    shouldSendGodavari = true;
  }

  if (ACM_GV_ANALYTICS === 'TRUE') {
    shouldSendGodavari = true;
  }

  if (ACM_GV_ANALYTICS === 'FALSE') {
    shouldSendGodavari = false;
  }

  return shouldSendGodavari;
};
